require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");

import "swiper/css/bundle";
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';


require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");

require("./custom/anchor.es6");
require("./custom/header.es6");
require("./custom/footer.es6");

if ($(".plyr-player").length > 0) {
    require("./custom/video-players.es6");
}

(function ($) {

    $(".floating-anchor-bar").length > 0 && require("./template_parts/floating_anchor_bar.es6");
    $(".timeline-box").length > 0 && require("./template_parts/timeline.es6");
    $(".slider").length > 0 && require("./template_parts/slider.es6");
    $(".faq").length > 0 && require("./template_parts/faq.es6");
    $(".logo-strip").length > 0 && require("./template_parts/logo_strip.es6");
    $(".-scroll-gsap, .-scroll-simple").length > 0 && require("./template_parts/text_with_image_02.es6");

})(jQuery);